import React, { useState, useEffect } from 'react'
import { Table, Input, Pagination, PaginationItem, PaginationLink, Button } from 'reactstrap'

import Loader from 'react-loaders'
import { primary_color } from '../../../../Helper/uiHelper'
import IconSet from '../../../../CMSComponent/icon'
import AddEditForm from './addEditForm'
import AutomaticCodeEditForm from './automaticCodeEditForm'
import { request } from '../../../../Redux/Sagas/requests/api'
import { checkIsAdminOrManager } from '../../../../helper'
import { useDispatch, useSelector } from 'react-redux'
import { setNotification } from '../../../../Redux/Reducers/notificationHandling'
import ChangeSequenceButton from './changeSequenceButton'
import MoveSequenceButton from './moveSequenceButton'
import CustomTableReloadButton from '../../../Common/customTableReloadButton'

const checkUserSelected = (users, uuid) => {
  if (users?.includes(uuid)) {
    return true
  } else {
    return false
  }
}

const CodesTable = ({ blockDetails, form, setBlocketails, isPlannedBlock }) => {
  const dispatch = useDispatch()
  const user = useSelector((state) => state.User.user)
  const [blockName, setBlockName] = useState('')
  const [lockerNumber, setLockerNumber] = useState('')
  const [code, setCode] = useState()
  const [note, setNote] = useState('')
  const [page, setPage] = useState(1)
  const [academicYear, setAcademicYear] = useState()

  const [selectedLocker, setSelectedLocker] = useState([])
  const [editData, setEditData] = useState(false)
  const [editableCell, setEditableCell] = useState({ row: null, col: null, originalCode: null, invalid: false })

  const [lockers, setLockers] = useState([])
  const [lockerData, setLockerData] = useState()
  const [isLoading, setIsLoading] = useState(false)

  const isAutomaticBlock = !!blockDetails?.is_automatic
  const isPlannedLockIdTab = isPlannedBlock && isAutomaticBlock
  const showBlockNameColumn = !isPlannedLockIdTab
  const showLockIdColumn = isAutomaticBlock
  const showCodeColumn = !isPlannedLockIdTab && (!isPlannedBlock || !isAutomaticBlock)
  const showSequenceColumn = isAutomaticBlock
  const showNotesColumn = !isPlannedLockIdTab

  const handleLockerSelection = (checked, locker) => {
    if (checked) {
      const newUser = [...selectedLocker]
      newUser?.push(locker)
      setSelectedLocker(newUser)
    } else {
      const newUser = [...selectedLocker]
      let index
      newUser?.map((item, i) => {
        if (item?.id === locker?.id) {
          index = i
        }
      })
      newUser?.splice(index, 1)
      setSelectedLocker(newUser)
    }
  }
  const refetchCode = () => {
    setIsLoading(true)
    request('get-code-by-location-id', 'POST', {
      location_id: blockDetails?.id,
      page,
      per_page: isPlannedLockIdTab ? 500 : 10,
      item_date_time_id_label: academicYear,
      location_id_label: blockName,
      name: lockerNumber,
      code,
      note,
      is_planned_block: !!isPlannedBlock,
    }).then((res) => {
      if (res?.data?.data) {
        setLockers(res?.data?.data?.data)
        setLockerData(res?.data)
      }
      setIsLoading(false)
    })
  }

  useEffect(() => {
    if (blockDetails?.id) {
      refetchCode()
    }
  }, [page, blockDetails?.id, isPlannedBlock, blockDetails?.is_automatic])

  const selectedLockerUUID = selectedLocker?.map((item) => item?.id)

  let isBlockEdit = true
  if (checkIsAdminOrManager(user?.role)) {
    isBlockEdit = false
  }

  const handleDoubleClick = (rowIndex, colIndex, item) => {
    if (item?.is_automatic || isBlockEdit) return
    setEditableCell({ row: rowIndex, col: colIndex, originalCode: item?.code ?? '', invalid: false })
  }

  const revertInlineCode = (index, originalCode) => {
    setLockers((current) => {
      const reverted = [...current]
      if (reverted[index]) {
        reverted[index] = { ...reverted[index], code: originalCode }
      }
      return reverted
    })
  }

  const handleChange = (index, value) => {
    const digits = String(value || '').replace(/\D/g, '')
    // Allow typing past 4 briefly so a bad paste can be shortened; do not save until exactly 4.
    if (digits.length > 8) {
      return
    }
    const newLockers = [...lockers]
    if (newLockers[index]?.is_automatic) return
    const previousCode = editableCell.originalCode ?? newLockers[index]['code']
    newLockers[index]['code'] = digits
    setLockers(newLockers)

    const invalid = digits.length > 0 && digits.length !== 4
    setEditableCell((prev) => ({ ...prev, invalid }))

    if (digits.length !== 4) {
      return
    }
    request('insert-codes', 'POST', { ...newLockers[index], code: digits }).then((res) => {
      if (res?.status === 200 || res?.status === 201 || res?.status === 202) {
        setEditableCell({ row: null, col: null, originalCode: null, invalid: false })
        return
      }
      dispatch(
        setNotification({
          type: 'error',
          message: res?.data?.message || 'Failed to update code',
        })
      )
      setEditableCell((prev) => ({ ...prev, invalid: true }))
      revertInlineCode(index, previousCode)
    })
  }

  const handleInlineBlur = (index) => {
    const current = String(lockers[index]?.code || '')
    const originalCode = editableCell.originalCode ?? ''
    if (current.length !== 4) {
      dispatch(setNotification({ type: 'error', message: 'Code must be exactly 4 digits.' }))
      revertInlineCode(index, originalCode)
    }
    setEditableCell({ row: null, col: null, originalCode: null, invalid: false })
  }

  if (editData) {
    if (editData?.is_automatic) {
      return (
        <AutomaticCodeEditForm
          defaultValue={{ ...editData, is_planned_block: !!isPlannedBlock }}
          onCloseForm={() => {
            refetchCode()
            setEditData()
          }}
        />
      )
    }
    return (
      <AddEditForm
        form={form}
        defaultValue={editData}
        blockDetails={blockDetails}
        onCloseForm={() => {
          refetchCode()
          setEditData()
        }}></AddEditForm>
    )
  }
  return (
    <div className='px-5 mt-4 merge-user-table'>
      <div className='float-right d-flex align-items-center'>
        {!isPlannedBlock && isAutomaticBlock ? (
          <MoveSequenceButton locationId={blockDetails?.id} lockers={lockers} onDone={refetchCode} />
        ) : null}
        <CustomTableReloadButton onReload={refetchCode} disabled={isLoading} id='block-codes-table-reload' />
      </div>
      <Table hover className='rt-table notes-type-table'>
        <thead className='rt-thead -header'>
          <tr className='rt-tr'>
            <th className='rt-th'></th>
            <th className='rt-th' style={{ border: 'none' }}></th>
            {showBlockNameColumn && (
              <th className='subtitle1 font-weight-bold  rt-th' style={{ color: primary_color }}>
                Block Name
              </th>
            )}
            <th className='subtitle1 font-weight-bold  rt-th' style={{ color: primary_color }}>
              Locker Number
            </th>
            {showLockIdColumn && (
              <th className='subtitle1 font-weight-bold  rt-th' style={{ color: primary_color }}>
                Lock ID
              </th>
            )}
            {showCodeColumn && (
              <th className='subtitle1 font-weight-bold  rt-th' style={{ color: primary_color }}>
                Codes
              </th>
            )}
            {showSequenceColumn && (
              <th className='subtitle1 font-weight-bold  rt-th' style={{ color: primary_color }}>
                Sequence
              </th>
            )}
            {showNotesColumn && (
              <th className='subtitle1 font-weight-bold  rt-th' style={{ color: primary_color }}>
                Notes
              </th>
            )}
          </tr>
          <tr className='rt-tr'>
            <th className='rt-th'></th>
            <th className='rt-th'></th>
            {showBlockNameColumn && (
              <th className='rt-th'>
                <Input type='text ' className='subtitle1' placeholder='Block' value={blockName} onChange={(e) => setBlockName(e.target.value)} />
              </th>
            )}
            <th className='rt-th'>
              <Input
                type='text '
                className='subtitle1'
                placeholder='Locker Number'
                value={lockerNumber}
                onChange={(e) => setLockerNumber(e.target.value)}
              />
            </th>
            {showLockIdColumn && <th className='rt-th'></th>}
            {showCodeColumn && (
              <th className='rt-th'>
                <Input type='text ' className='subtitle1' placeholder='Code' value={code} onChange={(e) => setCode(e.target.value)} />
              </th>
            )}
            {showSequenceColumn && <th className='rt-th'></th>}
            {showNotesColumn && (
              <th className='rt-th '>
                <Input type='text' className='subtitle1' placeholder='Note' value={note} onChange={(e) => setNote(e.target.value)} />
              </th>
            )}
          </tr>
        </thead>
        <tbody className='rt-tr-group'>
          {isLoading ? (
            <tr className='rt-tr'>
              <td colSpan={8} className='rt-td'>
                <div className='d-flex justify-content-center' style={{ marginTop: '4rem', marginBottom: '8rem' }}>
                  <Loader type='ball-pulse' color='blue' />
                </div>
              </td>
            </tr>
          ) : (
            <>
              {lockers?.map((item, rowIndex) => {
                const rowIsAutomatic = !!item?.is_automatic
                return (
                  <tr key={item.id} className={`${rowIndex % 2 === 0 && 'row-odd'}`}>
                    <td className='rt-td'>
                      <input
                        type='checkbox'
                        checked={checkUserSelected(selectedLockerUUID, item?.id)}
                        onChange={(e) => handleLockerSelection(e.target.checked, item)}></input>
                    </td>
                    <td className='rt-td'>
                      <Button
                        className={`btn-icon btn-icon-only btn btn-primary btn-sm`}
                        style={{ background: primary_color }}
                        disabled={isBlockEdit}
                        onClick={() => {
                          setEditData(item)
                        }}>
                        <IconSet icon='far fa-edit' color='light' />
                      </Button>
                    </td>
                    {showBlockNameColumn && <td className='subtitle1 rt-td'>{item.location_id_label}</td>}
                    <td className='subtitle1 rt-td'>{item.name}</td>
                    {showLockIdColumn && (
                      <td className='subtitle1 rt-td'>{rowIsAutomatic ? item.lock_id || '—' : '—'}</td>
                    )}
                    {showCodeColumn && (
                      <td
                        className='rt-td subtitle1'
                        onClick={() => handleDoubleClick(rowIndex, 0, item)}
                        style={{}}>
                        {item?.is_automatic ? (
                          item?.code
                        ) : editableCell.row === rowIndex && editableCell.col === 0 ? (
                          <input
                            type='text'
                            value={item.code}
                            onChange={(e) => handleChange(rowIndex, e.target.value)}
                            onBlur={() => handleInlineBlur(rowIndex)}
                            maxLength={8}
                            inputMode='numeric'
                            disabled={isBlockEdit}
                            autoFocus
                            style={{
                              border: editableCell.invalid ? '1px solid #dc3545' : 'none',
                              outline: 'none',
                              width: '100%',
                              backgroundColor: editableCell.invalid ? '#fff5f5' : undefined,
                            }}
                          />
                        ) : (
                          item?.code
                        )}
                      </td>
                    )}
                    {showSequenceColumn && (
                      <td className='subtitle1 rt-td'>
                        {rowIsAutomatic ? (
                          <>
                            {item.code_sequence || '—'}{' '}
                            {!isPlannedLockIdTab ? (
                              <ChangeSequenceButton item={item} onDone={refetchCode} />
                            ) : null}
                          </>
                        ) : (
                          '—'
                        )}
                      </td>
                    )}
                    {showNotesColumn && <td className='subtitle1 rt-td' dangerouslySetInnerHTML={{ __html: item.note }}></td>}
                  </tr>
                )
              })}
            </>
          )}
        </tbody>
      </Table>

      {!isPlannedLockIdTab ? (
        <div className='d-flex justify-content-center'>
          <Pagination aria-label='Page navigation example' style={{ flexWrap: 'wrap' }}>
            {lockerData?.data?.links?.map((item, key) => {
              return (
                <PaginationItem active={item.active} disabled={item.url === null} key={key} className='subtitle1'>
                  <PaginationLink
                    first
                    onClick={() => {
                      if (item?.label?.toLowerCase()?.includes('previous')) {
                        setPage(parseInt(lockerData?.data?.current_page) - 1)
                      } else if (item?.label?.toLowerCase()?.includes('next')) {
                        setPage(parseInt(lockerData?.data?.current_page) + 1)
                      } else {
                        setPage(parseInt(item?.label))
                      }
                    }}
                    className='subtitle1'>
                    {item.label.replace('&laquo;', '').replace('&raquo;', '')}
                  </PaginationLink>
                </PaginationItem>
              )
            })}
          </Pagination>
        </div>
      ) : null}
    </div>
  )
}

export default CodesTable
